import axios from "axios";

// Backend URL is baked in at build time via REACT_APP_BACKEND_URL.
// - Web build: same-origin possible, but env is always set in this project.
// - Native (Capacitor) build: env MUST contain the absolute production URL, because
//   the app is served from `capacitor://localhost` which is NOT same-origin.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export const API = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";

// Auth uses httpOnly + Secure + SameSite=None cookies (cross-origin capable for native).
// withCredentials:true tells the browser/webview to send cookies on every request.
const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;
